import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {http} from 'hiya-common/src/utils/axios'
import {cloneDeep, isEqual} from 'lodash'
import {
  IChannelItem,
  IOfficeChannelItem,
  IProductsReq,
  IProductsResp,
  IProfileResp,
  IThirdPartyItem,
  IWebThirdPartyItem,
} from '../reducers'
import {formatProduct} from '../utils'
import {ICouponSt, IUserCouponsReq, IUserCouponsResp} from '../service'

export const get_products_list_v2 = createAsyncThunk(
  '/live/pay/get_products_list_v2',
  async (productsReq: IProductsReq, store: any) => {
    console.log('get_products_list_v2', productsReq)
    const resp = await http.post<{data: IProductsResp}>(
      `/live/pay/get_products_list_v2`,
      {
        ...store.getState().env.deviceinfo,
        ...productsReq,
      }
    )

    return resp.data.data
  }
)

export const query_order_h5 = createAsyncThunk(
  '/live/pay/query_order_h5',
  async (params: {order_id: string}, store: any) => {
    const resp = await http.post<{data: any}>(
      `/live/pay/query_order_h5`,
      {
        ...store.getState().env.deviceinfo,
        ...params,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

export const getProfile = createAsyncThunk(
  '/live/account/profile',
  async (params, store: any) => {
    const resp = await http.post<{data: IProfileResp}>(
      '/live/account/profile',
      {
        ...store.getState().env.deviceinfo,
      }
    )

    return resp.data.data
  }
)
/** 获取优惠卡券信息 */
export const getUserCoupons = createAsyncThunk(
  '/live/pay/get_user_coupons',
  async (params: IUserCouponsReq, store: any) => {
    const resp = await http.post<{data: IUserCouponsResp}>(
      '/live/pay/get_user_coupons',
      {
        ...store.getState().env.deviceinfo,
        name: 'Weekly recharge',
        limit: 100,
        ...params,
      }
    )
    return resp.data.data
  }
)

const initialState: {
  curPage: string
  curProduct: IThirdPartyItem & IWebThirdPartyItem
  curChannel: IChannelItem & IOfficeChannelItem & {tag: string}
  productList: (IThirdPartyItem & IWebThirdPartyItem)[]
  oldUserProductIdList: any[]
  productListResp: IProductsResp
  isProductListFetched: boolean
  couponList: ICouponSt[]
} = {
  curPage: 'wallet',
  curProduct: {} as IThirdPartyItem & IWebThirdPartyItem,
  curChannel: {} as IChannelItem & IOfficeChannelItem & {tag: string},
  productList: [],
  oldUserProductIdList: [],
  productListResp: {
    list: [],
    coins: 0,
    is_recharged: false,
    third_party_list: [],
    countries: [],
    default_country: {
      code: undefined,
      name: '',
    },
    huawei_list: [],
    is_first_recharge: false,
    extra_desc_url: '',
    is_audit_ver: false,
    show_feedback_popup: false,
    desc: '',
    can_show_agency_list: false,
    order_exp: false,
    need_info_channel: [],
    pay_page_exp_type: 0,
    abt: '',
    third_party_list_v3: [],
    show_coupon: false,
    activity_discount: null,
  },
  isProductListFetched: false,
  couponList: [],
}

export const WalletAdvancedOldUserRechargeSlice = createSlice({
  name: 'WalletAdvancedOldUserRecharge',
  initialState,
  reducers: {
    setCurPage: (state, action) => {
      Object.assign(state, {curPage: action.payload})
    },
    setCurProduct: (state, action) => {
      Object.assign(state, {curProduct: action.payload})
    },
    setCurChannel: (state, action) => {
      Object.assign(state, {curChannel: action.payload})
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(inviteInfo.fulfilled, (state, action) => {
    //   const {data = {}} = action.payload
    //   Object.assign(state.invite_info, data)
    // })
    builder.addCase(get_products_list_v2.fulfilled, (state, action) => {
      const resp = action.payload
      const {
        list,
        coins,
        is_recharged,
        third_party_list,
        countries,
        default_country,
        huawei_list,
        is_first_recharge,
        extra_desc_url,
        is_audit_ver,
        show_feedback_popup,
        desc,
        order_exp,
        need_info_channel,
        pay_page_exp_type,
        abt,
        third_party_list_v3,
        show_coupon,
        activity_discount,
      } = resp

      Object.assign(state, {
        productListResp: {
          list,
          coins,
          is_recharged,
          third_party_list: third_party_list || [],
          countries: countries || [],
          default_country: default_country || {},
          huawei_list,
          is_first_recharge,
          extra_desc_url,
          is_audit_ver,
          show_feedback_popup,
          desc,
          order_exp,
          need_info_channel,
          pay_page_exp_type,
          abt,
          third_party_list_v3: third_party_list_v3 || [],
          show_coupon,
          activity_discount,
        },
        isProductListFetched: true,
      })
      const formatList = cloneDeep(formatProduct(resp))
      if (!isEqual(formatList, state.productList)) {
        Object.assign(state, {productList: formatList})
      }
      const oldUserProductIdList = Object.values(
        activity_discount?.return_recharge_cfg || {}
      ).reduce((result, next) => {
        if (next.activity === 'return_recharge') {
          return [
            ...result,
            ...(next.official_ids || []).map((id) => ({
              id,
              pay_amount: next.pay_amount,
              activity_type: next.activity,
              sub_activity_type: '',
              bonus_coin: next.bonus_coin,
              currency: next.currency,
              limit: next.limit,
              num: next.num,
              total_coin: next.total_coin,
              ratio: next.ratio,
            })),
            ...(next.third_party_product_ids || []).map((id) => ({
              id,
              pay_amount: next.pay_amount,
              activity_type: next.activity,
              sub_activity_type: '',
              bonus_coin: next.bonus_coin,
              currency: next.currency,
              limit: next.limit,
              num: next.num,
              total_coin: next.total_coin,
              ratio: next.ratio,
            })),
          ]
        }
        return result
      }, [])
      if (!isEqual(oldUserProductIdList, state.oldUserProductIdList)) {
        Object.assign(state, {oldUserProductIdList})
      }
      // Object.assign(state, {productList: formatList})
    })

    builder.addCase(getUserCoupons.fulfilled, (state, action) => {
      const {coupon_list} = action.payload
      Object.assign(state, {
        couponList: coupon_list,
      })
    })
  },
})

export default WalletAdvancedOldUserRechargeSlice.reducer

export const WalletAdvancedOldUserRechargeActions =
  WalletAdvancedOldUserRechargeSlice.actions
export const useWalletAdvancedOldUserRechargeState = () => {
  const data = useSelector((state) => {
    return state.WalletAdvancedOldUserRecharge
  })
  return data
}
